import React from "react";
import KYCAadhar from "../Components/KYCAadhar";
import KYCGst from "../Components/KYCGst";

function KYC() {
  return (
    <section className="content">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12">
          {" "}
          <div class="card mb-0">
            <div class="card-header">
              <h3 class="card-title">KYC</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  className="col-lg-6 mt-2"
                  style={{ marginTop: 10, marginBottom: 10 }}
                >
                  <KYCAadhar />
                </div>
                {/* <div
            className="col-lg-6 mt-2"
            style={{ marginTop: 10, marginBottom: 10 }}
          >
            <KYCPan />
          </div> */}
                {localStorage.getItem("usertypecategory") !== "Individual" && (
                  <div
                    className="col-lg-6 mt-2"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  >
                    <KYCGst />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default KYC;
